var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_657",
    "data-name": "Group 657",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.262,
    height: 51.261,
    viewBox: "0 0 51.262 51.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2236",
    "data-name": "Path 2236",
    d: "M25.63,0A25.63,25.63,0,1,1,0,25.63,25.63,25.63,0,0,1,25.63,0Z",
    fill: "#0b2a46",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "de5c86ec3adb5fb7218b18e9d20f6364",
    d: "M15.5,5.468h1.964V2.146A27.275,27.275,0,0,0,14.6,2C11.76,2,9.817,3.734,9.817,6.91V9.647H6.61v3.719H9.817v9.527h3.844V13.365h3.2l.481-3.719H13.661V7.275C13.661,6.178,13.954,5.468,15.5,5.468Z",
    transform: "translate(13.44 13.038)",
    fill: "#e4e4e4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5db0744650fcdfa9bfac43c1cabcecc8.svg";
export { ForwardRef as ReactComponent };